export const COLORS = {
  // colors from Audi color palette
  white: '#ffffff',
  white90: '#ffffffe6',
  black: '#000000',
  grey5: '#f2f2f2',
  grey10: '#e5e5e5',
  grey15: '#d9d9d9',
  grey20: '#cccccc',
  grey25: '#aeaeae',
  grey30: '#b3b3b3',
  grey40: '#999999',
  grey50: '#808080',
  grey60: '#666666',
  grey70: '#4c4c4c',
  grey80: '#333333',
  grey90: '#1a1a1a',
  audiRed: '#f50537',
  pinkSwan: '#b7b7b7',
  whisper: '#eaeaea',
  error: '#EB0D3F',
  menuBorder: '#B9B9B9',
  menuBackground: '#E1E1E1',
  menuTextColor: '#222222',
  spaceInvader: '#0DA20D',
};

type ColorKeys = keyof typeof COLORS;

export type Color = (typeof COLORS)[ColorKeys];

export const SIZING = {
  unit: (times: number): string => `${times * 8}px`,
};
